import { CollectionStore } from 'modules/base';

export class ManagerDiscoveryQuestionsStore extends CollectionStore {
  baseUrl = '/manager-discovery';
}
